import { userLogout } from './userContextStore';
import { fetchFromLocalStorage } from './storeFunctions';
const LOCATION_CHANGE = '@@router/LOCATION_CHANGE'; // hardcoded to save 9KB lib link just to get one value

const SET_VIEW = "SET_VIEW";
const EXPAND_LEFT_PANEL = "EXPAND_LEFT_PANEL";
const EXPAND_TOP_MENU = "EXPAND_TOP_MENU";
const TOGGLE_SEARCH_MOBILE_FILTER = "TOGGLE_MOBILE_SEARCH_FILTER";
const TOGGLE_SECTIONS_MOBILE_MENU = "TOGGLE_SECTIONS_MOBILE_MENU";
const TOGGLE_ACCOUNT_MOBILE_MENU = 'TOGGLE_ACCOUNT_MOBILE_MENU';
const TOGGLE_BURGER_MOBILE_MENU = 'TOGGLE_BURGER_MOBILE_MENU';
const TOGGLE_NOTIFICATIONS_MOBILE_MENU = 'TOGGLE_NOTIFICATIONS_MOBILE_MENU';
const SET_TOPMENU_HEIGHT = "SET_TOPMENU_HEIGHT";
const SET_REPORTHEADER_HEIGHT = 'SET_REPORTHEADER_HEIGHT';
const SET_SCROLLED = 'SET_SCROLLED';
const TOGGLE_LAST_SEARCHED = "TOGGLE_LAST_SEARCHED";
const TOGGLE_MORE_ITEMS = "TOGGLE_MORE_ITEMS";
const UPDATE_SCROLL_TOP = "UPDATE_SCROLL_TOP";
const TOGGLE_SETTINGS_MENU = "TOGGLE_SETTINGS_MENU";

const initialState = {
    leftPanelFixed: false,
    view: "normal",
    topMenuExpanded: false,
    footer: {
        height: 0,
        visibleHeight: 50
    },
    isSearchMobileFilterToggled: false,
    isSectionsMobileMenuToggled: false,
    isAccountMobileMenuToggled: false,
    isBurgerMobileMenuToggled: false,
    isNotificationsMobileMenuToggled: false,
    topMenuHeight: "3.5rem",
    pageHeaderHeight: 0,
    scrolled: false,
    areLastSearchedVisible: false,
    areMoreLinksVisible: false,
    isSettingsMenuToggled: false,
    scrollTop: 0,
    helpMap: fetchFromLocalStorage('help_map', [])
};

export const layoutActions = {
    getLeftPanelSize: () => (_, getState) => getState().layout.leftPanelFixed ? '16em' : '4em',
    expandLeftPanel: () => (dispatch, getState) => {
        dispatch({ type: EXPAND_LEFT_PANEL });
    },
    setView: (view) => (dispatch, getState) => {
        dispatch({ type: SET_VIEW, data: view });
    },
    expandTopMenu: () => (dispatch, getState) => {
        dispatch({ type: EXPAND_TOP_MENU });
    },
    toggleSearchMobileFilter: () => dispatch => {
        dispatch({ type: TOGGLE_SEARCH_MOBILE_FILTER });
    },
    toggleSectionsMobileMenu: () => dispatch => {
        dispatch({ type: TOGGLE_SECTIONS_MOBILE_MENU });
    },
    setPageHeaderHeight: (height) => dispatch => {
        dispatch({ type: SET_REPORTHEADER_HEIGHT, data: height });
    },
    setScrolled: (boolean) => dispatch => {
        dispatch({ type: SET_SCROLLED, data: boolean });
    },
    toggleAccountMobileMenu: () => dispatch => {
        dispatch({ type: TOGGLE_ACCOUNT_MOBILE_MENU });
    },
    toggleBurgerMobileMenu: () => dispatch => {
        dispatch({ type: TOGGLE_BURGER_MOBILE_MENU });
    },
    toggleNotificationsMobileMenu: () => dispatch => {
        dispatch({ type: TOGGLE_NOTIFICATIONS_MOBILE_MENU });
    },
    toggleLastSearchedSubjects: () => dispatch => {
        dispatch({ type: TOGGLE_LAST_SEARCHED });
    },
    toggleMoreItems: () => dispatch => {
        dispatch({ type: TOGGLE_MORE_ITEMS });
    },
    updateScrollTop: (position) => dispatch => {
        dispatch({ type: UPDATE_SCROLL_TOP, position });
    },
    toggleSettingsMenu: () => dispatch => {
        dispatch({ type: TOGGLE_SETTINGS_MENU });
    },
    isIpad: () => () => /iPad|iPhone|iPod/.test(navigator.userAgent)

};

// store reducer
export const reducer = (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case LOCATION_CHANGE:
            window.scrollTo({ top: 0, behavior: 'smooth' })
            return { ...state, location: action.payload.pathname };
        case 'STORAGE_CHANGED':
            if(action.key !== 'help_map') {
                return state;
            }
            const data = fetchFromLocalStorage('help_map', state.helpMap);
            if(JSON.stringify(data) === JSON.stringify(state.helpMap)) {
                return state;
            }
            return {...state, helpMap: data};
        case SET_VIEW:
            return { ...state, view: action.data };
        case EXPAND_TOP_MENU:
            return { ...state, topMenuExpanded: !state.topMenuExpanded };
        case TOGGLE_SEARCH_MOBILE_FILTER:
            return { ...state, isSearchMobileFilterToggled: !state.isSearchMobileFilterToggled, isBurgerMobileMenuToggled: false };
        case TOGGLE_SECTIONS_MOBILE_MENU:
            return { ...state, isSectionsMobileMenuToggled: !state.isSectionsMobileMenuToggled, isBurgerMobileMenuToggled: false };
        case TOGGLE_ACCOUNT_MOBILE_MENU:
            return { ...state, isAccountMobileMenuToggled: !state.isAccountMobileMenuToggled, isBurgerMobileMenuToggled: false };
        case TOGGLE_BURGER_MOBILE_MENU:
            return { ...state, isBurgerMobileMenuToggled: !state.isBurgerMobileMenuToggled };
        case TOGGLE_NOTIFICATIONS_MOBILE_MENU:
            return { ...state, isNotificationsMobileMenuToggled: !state.isNotificationsMobileMenuToggled , isBurgerMobileMenuToggled: false};
        case userLogout:
            return {
                ...state, isSearchMobileFilterToggled: false, isSectionsMobileMenuToggled: false,
                isAccountMobileMenuToggled: false, isNotificationsMobileMenuToggled: false,
                isBurgerMobileMenuToggled: false
            }
        case SET_TOPMENU_HEIGHT:
            return { ...state, topMenuHeight: action.data };
        case SET_REPORTHEADER_HEIGHT:
            return { ...state, pageHeaderHeight: action.data };
        case SET_SCROLLED:
            return { ...state, scrolled: action.data };
        case TOGGLE_LAST_SEARCHED:
            return { ...state, areLastSearchedVisible: !state.areLastSearchedVisible };
        case TOGGLE_MORE_ITEMS:
            return { ...state, areMoreLinksVisible: !state.areMoreLinksVisible };
        case UPDATE_SCROLL_TOP:
            return { ...state, scrollTop: action.position };
        case TOGGLE_SETTINGS_MENU:
            return { ...state, isSettingsMenuToggled: !state.isSettingsMenuToggled };
        default:
            return state;
    }
}